import { React, useState, useEffect } from 'react'
import { Box, Typography, SelectField } from 'components'
import { getDaysInMonth, setDate, setMonth, setYear, getDate, getMonth, getYear } from 'date-fns'


const FreelancerWorkStatusExpiry = ({ onUpdate = state => { } }) => {
    const [state, setState] = useState(new Date())
    const [dayChoices, setDayChoices] = useState([{}])

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const monthChoices = months.map((month, index) => ({ label: month, value: index }))
    const yearChoices = Array.from(new Array(10), (val, index) => index + new Date().getFullYear()).map((year) => ({ label: year, value: year }))

    const handleChange = e => {
        const { name, value } = e.target
        switch (name) {
            case 'year':
                setState(setYear(state, value))
                break
            case 'month':
                setState(setMonth(state, value))
                break
            case 'day':
                setState(setDate(state, value))
                break
            default:
                break
        }
        onUpdate(state)
    }

    useEffect(() => {
        setDayChoices(Array.from(new Array(getDaysInMonth(state.getFullYear(), state.getMonth())), (val, index) => ({ label: index + 1, value: index + 1 })))
    }, [state])

    return (
        <Box flexVariant='row align-space-between'>
            <Typography variant="caption">Optional: Provide the expiry date of your work permit:</Typography>
            <SelectField name='year' label={'Year'} value={getYear(state)} choices={yearChoices} onChange={handleChange} />
            <SelectField name='month' label={'Month'} choices={monthChoices} value={getMonth(state)} onChange={handleChange} />
            <SelectField name='day' label={'Day'} choices={dayChoices} value={getDate(state)} onChange={handleChange} />
        </Box>
    )
}

export { FreelancerWorkStatusExpiry }